import {
    MODAL_POLICY_HIDE, MODAL_POLICY_SHOW, SET_CUSTOMER_DATA
} from './../constants/constants';
import { navigateTo } from './../actions/navigationActions';
import { PERSONAL_DETAILS } from './../routes/routes';

export const hideModal = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_POLICY_HIDE,
        });
    }
}

export const showModalInvalidEmail = () => {
    return (dispatch, getState) => {
        let body = `<p class="noma">Your email address is invalid. We need it to communicate with you.</p>`;

        dispatch({
            type: MODAL_POLICY_SHOW,
            modalProps: {
                titleImage: './images/icons-line-style-info-32-px.svg',
                titleText: 'Oops',
                body: body,
                okButtonText: 'Update email',
                okButtonEvent: () => {
                    dispatch(navigateTo(PERSONAL_DETAILS));

                    dispatch({ type: SET_CUSTOMER_DATA, payload: { isEditMode: true } });
                },
                cancelButtonText: "I'll do it later",
            }
        });
    }
}

export const showModalNoEmail = () => {
    return (dispatch, getState) => {
        let body = `<p class="noma">Your email address is missing. We need it to communicate with you.</p>`;

        dispatch({
            type: MODAL_POLICY_SHOW,
            modalProps: {
                titleImage: './images/icons-line-style-info-32-px.svg',
                titleText: 'Oops',
                body: body,
                okButtonText: 'Add email',
                okButtonEvent: () => {
                    dispatch(navigateTo(PERSONAL_DETAILS));

                    dispatch({ type: SET_CUSTOMER_DATA, payload: { isEditMode: true } });
                },
                cancelButtonText: "I'll do it later"
            }
        });
    }
}